import { hsaAnswer } from "@redotech/redo-conversion-hsa-common/hsa-answer";
import {
  hsaPortalGroup,
  hsaSessionState,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const stepHandle = z.string().min(1).max(200);

/**
 * One step of a card-paid reimbursement's LMN questionnaire. The client holds
 * every answer and sends them all; the server stores none and returns none.
 */
export const getHsaReimbursementLmnStep = {
  name: "getHsaReimbursementLmnStep" as const,
  input: z.object({
    orderId: zExt.objectId(),
    /** The LMN lines being claimed. */
    lineItemIds: z.array(z.string().min(1)).min(1).max(100),
    answers: z.record(z.string(), hsaAnswer),
    move: z.discriminatedUnion("kind", [
      z.object({ kind: z.literal("first") }),
      z.object({ kind: z.literal("next"), from: stepHandle }),
      z.object({ kind: z.literal("previous"), from: stepHandle }),
      z.object({ kind: z.literal("goTo"), to: stepHandle }),
    ]),
  }),
  output: z.object({
    state: hsaSessionState,
    /** Invalid answers on the step being left; the state stays on that step. */
    errors: z.array(z.object({ questionHandle: z.string(), code: z.string() })),
    /** 1-based position on the walked path; null for a terminal. */
    stepNumber: z.number().nullable(),
    /** The step's page position on the projected path; null for a terminal. */
    progress: z
      .object({ pagesBefore: z.number(), pageCount: z.number() })
      .nullable(),
    /** The finished walk's steps, questions only; empty until complete. */
    reviewSteps: z.array(hsaPortalGroup),
  }),
};
